/** API key strings for Company Settings -> API Keys (PREC-4410: the modal asked for keys no file held). */
export const enApiKey = {
	name: "Name",
	create: {
		title: "Create API key",
	},
};
